import ThemeProvider from "../context/ThemeContext";
import AlertProvider from "../context/AlertContext";
import AuthProvider  from "../context/AuthContext";
import Alert         from "../modules/components/Alert";

export default function AppProviders({ children }) {
  return (
    <ThemeProvider>
      <AlertProvider>
        <AuthProvider>
          {children}
          <Alert />
        </AuthProvider>
      </AlertProvider>
    </ThemeProvider>
  );
}
